import { Row, Col } from "react-bootstrap";
import AnimButton from "../../components/animbutton";
import { achievements } from "../../content_option";

export const Awards = () => {
    return (
        <>
            <Col lg={{ span: 4, offset: 1}}>
                <h3 className="color_sec py-4 ">Awards</h3>
            </Col>
            <Col lg="7">
                {
                    achievements.map((data, index) => {
                        return (
                            <>
                                <Row className="award_header">
                                    <Col lg="12" className="d-flex justify-content-start">
                                        {data.title}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="d-flex justify-content-start">
                                        Issuer: {data.issuer}
                                    </Col>
                                    <Col className="d-flex justify-content-end">
                                        {data.date}
                                    </Col>
                                </Row>
                                <Row className="mx-0 mb-5">
                                    <p>
                                        {data.description}
                                    </p>
                                    <a href={data.eventUrl}>
                                        <AnimButton title="Go to Portal" />
                                    </a>
                                </Row>
                            </>
                        )
                    })
                }
            </Col>
        </>
    )
}